var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('router-link',{attrs:{"to":{ name: 'Intsearch' }}},[_c('input',{staticClass:"search-profile",attrs:{"type":"search","name":"","placeholder":"Go to search..."}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }